import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminBookings from "@/pages/AdminBookings";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AnalyticsPing = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      let sid = sessionStorage.getItem("apa_sid");
      if (!sid) {
        sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem("apa_sid", sid);
      }
      const firstPing = !sessionStorage.getItem("apa_ref_sent");
      sessionStorage.setItem("apa_ref_sent", "1");
      fetch(`${API}/analytics/ping`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sid,
          path: location.pathname,
          referrer: firstPing ? document.referrer || "" : "",
        }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* analytics must never break the site */
    }
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-slate-50 text-slate-900 antialiased">
      <BrowserRouter>
        <AnalyticsPing />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminBookings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
